import { FC, useCallback, useContext, useEffect, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Menu } from "../../../components/menu"
import update from 'immutability-helper'


import { FileUploader } from "react-drag-drop-files";
import { DndProvider, useDrag, useDrop } from "react-dnd";

import { HTML5Backend } from "react-dnd-html5-backend";
import { Card, ImageItem } from "./card";
import { UseCasesContext } from "../../../../context/useCases";

const fileTypes = ["JPEG", "JPG", "PNG", "GIF"];


export const UploadPage = () => {
    const navigate = useNavigate();
    const MAX_PHOTO_SIZE = 4

    let { landingId, year, month } = useParams();

    const [files, setFiles] = useState<{ id: number, file: File }[]>([]);
    const [loading, setLoading] = useState(false)

    let useCases = useContext(UseCasesContext)


    const handleChange = (filesDrop: FileList) => {
        let filesList: { id: number, file: File }[] = []
        let currentId = getMaxId();

        for (let i = 0; i < filesDrop.length; i++) {
            filesList[i] = { id: currentId, file: filesDrop.item(i)! };
            currentId++;
        }

        filesList.sort((a, b) => {
            return a.file.name.localeCompare(b.file.name);
        })

        setFiles([...filesList, ...files]);
    };

    const getMaxId = () => {
        let maxId = 0;
        files.map((file) => {
            if (file.id > maxId) {
                maxId = file.id;
            }
        })

        return maxId + 1;
    }

    const moveFile = useCallback((dragIndex: number, hoverIndex: number) => {
        setFiles((prevFiles: {
            id: number;
            file: File;
        }[]) =>
            update(prevFiles, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, prevFiles[dragIndex]],
                ],
            }),
        )
    }, [])

    const removeFile = useCallback((index: number) => {
        setFiles((prevFiles: {
            id: number;
            file: File;
        }[]) =>
            update(prevFiles, {
                $splice: [[index, 1]],
            }),
        )
    }, [])

    const readFilesOfMonth = async () => {
        setFiles([])
        setLoading(true)
        let response = await useCases?.uploadtaskUseCase.ReadMonthsImagesOfSite(landingId!, parseInt(year!), parseInt(month!))
        if (response instanceof Error) {

        } else {
            let filesList: { name: string, file: File }[] = []
            await Promise.all(response!.map(async (file) => {
                filesList.push({ name: file, file: (await readFile(file))! })
            }))

            let files: { id: number, file: File }[] = []

            let id = getMaxId()
            filesList.sort((a, b) => a.name.localeCompare(b.name))
            filesList.map((file) => {
                files.push({ id: id, file: file!.file })
                id++
            })

            setFiles(files)
        }

        setLoading(false)
    }


    const readFile = async (fileName: string) => {
        let file = await useCases?.uploadtaskUseCase.ReadImageFromUrl(landingId!, year!, month!, fileName)
        return file
    }

    useEffect(() => {
        readFilesOfMonth()
    }, [])


    const uploadFiles = async () => {
        setLoading(true)
        let response = await useCases?.uploadtaskUseCase.UploadFiles(landingId!, year!, month!, files.map((file) => file.file), () => { navigate(-1)})

        setLoading(false)
        console.log(response)
    }






    return (
        <div className="layout-page" >
            <Menu />
            <div className="content-wrapper" >
                <div className="container-xxl flex-grow-1 container-p-y">
                    {!loading ? <div className="row mx-1">
                        <div className="col-sm-12 col-md-4">
                            <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Загрузка фото /</span> Страница загрузки</h4>
                        </div>

                        <div className="card-body">
                            <FileUploader
                                multiple={true}
                                handleChange={handleChange}
                                name="file"
                                label="Загрузите или перетащите файл(-ы) сюда"
                                types={fileTypes}
                                maxSize={20}
                            />

                        </div>

                        {files ? <div className="row">
                            <div className="mt-3">
                                <div className="text-light small fw-semibold" style={{ marginBottom: "10px" }}>Фото</div>



                                <DndProvider backend={HTML5Backend}>
                                    <div className="row mb-5" role="group" aria-label="Basic example">
                                        {files.map((file, index) => {
                                            return <Card
                                                key={file.id}
                                                index={index}
                                                id={file.id}
                                                text={<ImageItem id={file.id} file={file.file} index={index} removeCard={removeFile} />}
                                                moveCard={moveFile}
                                            />
                                        })}

                                    </div>
                                </DndProvider>
                            </div>
                        </div> : <div></div>}

                        <div className="col-sm-12 col-md-12">
                            <div className="dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-md-end justify-content-center flex-wrap me-1">
                                <div className="dt-buttons py-3 mb-4">
                                    <a href={"#"} className="dt-button add-new btn btn-primary mb-3 mb-md-0" onClick={(e) => { e.preventDefault(); uploadFiles() }} ><span>Сохранить</span></a>
                                </div>
                            </div>
                        </div>

                    </div> : <div className="row">
                        <div className="mt-3">
                            <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Загрузка...  </span></h4>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    )

}